import moment from 'moment';

function toDateFormatter(value: any, format: any) {
    let theFormat: string =  'ddd, DD MMM YYYY';
    if (format) {
        theFormat = format;
    }
    if (value) {
        return moment(String(value)).format(theFormat);
    } else {
        return '';
    }
}

export default toDateFormatter;


